import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('droneMultiSelectPanelField');

    return {
        NO_DRONES_FOUND: t('noDronesFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
